export default "__VITE_ASSET__BBkEXTin__"